export const apiVersion = 'v2.2.0'
export const apiBrowserCacheTime = 300
export const apiEdgeCacheTime = 2592000
